/**
 * หน้ารับใบสั่งซื้อของลูกค้าเข้าเป็นใบสั่งขาย — `?view=receive` บน
 * `/sales/sales-orders` (D-116 ข้อ 3, 6, 8, 9 และ 10, `WO-P2-M4-010`)
 *
 * ขั้นที่สองของหน้านี้ ต่อจาก `WO-P2-M4-008` (D-116 ข้อ 6 ขั้นที่หนึ่ง) — สี่เรื่อง
 * ที่เปลี่ยนไปจากขั้นแรก ไล่จากสิ่งที่แพงที่สุดเมื่อผิด:
 *
 * 1. **ส่งผ่าน `POST /v1/sales-orders/import` (D-092) เสมอ ไม่ใช่ `POST
 *    /v1/sales-orders` อีกต่อไป** (D-116 ข้อ 9) — ทั้งกรอกมือและหลัง upload เดิน
 *    ทางเดียวกัน เพราะพรีวิวทำนายผลด้วยตรรกะของ D-092 (`would_be`) หน้าที่ทำนาย
 *    อย่างหนึ่งแล้วส่งไปอีกทางคือหน้าที่โกหก ผลจริงมาเป็นหนึ่งในสาม
 *    (`CREATED`/`DUPLICATE_IGNORED`/`REVISION_RAISED`) เสมอ ไม่ใช่แค่ "สร้างสำเร็จ"
 * 2. **ปุ่ม Upload Excel ย้ายมาอยู่ที่นี่แล้ว พร้อมเส้น preview** (D-116 ข้อ 5 และ
 *    10) — เลือกไฟล์ → เรียก `POST /v1/sales-orders/import-spreadsheet/preview`
 *    (**ไม่เขียนอะไรเลย**) → เติมแถวที่อ่านได้ลง**ตารางเดียวกับที่กรอกมือ** พร้อม
 *    แสดง `would_be` ให้เห็นก่อนกดส่งจริง แก้ต่อในตารางได้เหมือนบรรทัดที่พิมพ์เอง
 *    ปุ่ม upload เดิมบนหน้ารายการ (`SalesOrderScreen.tsx`) ถูกถอดออกแล้ว — มีทาง
 *    เดียวที่ถูก ไม่ใช่สองทางที่ทำงานต่างกัน
 * 3. **ไม่มีช่องเลขที่ใบสั่งขายอีกต่อไป** (D-113, D-116 ข้อ 6) — เซิร์ฟเวอร์ออกเลข
 *    เองเป็น `SO-<plant_code>-<YYMM>-<6 หลัก>` เสมอ ทั้ง `CreateSalesOrderFields`
 *    และ `CreateSalesOrderBody` ไม่มีคีย์นี้ให้ใส่แล้ว (ดู `lib/sales/types.ts`)
 * 4. **ตารางกรอกมี Ref1–Ref6** (D-107 ข้อ 2, D-116 ข้อ 8) — `serializeCreateSalesOrderBody`
 *    ส่งครบสิบเอ็ดคีย์ต่อบรรทัดแล้ว ไม่ใช่ห้าคีย์เหมือนขั้นแรก ช่องว่างส่งเป็น
 *    `null` (ไม่ได้บันทึก) ไม่ใช่ `""` (บันทึกเป็นค่าว่าง)
 *
 * สองเรื่องที่ยังเหมือนขั้นแรกทุกประการ:
 *
 * - **โรงงานและลูกค้าเป็น Select** — โรงงานมาจาก `plant_scope` ที่โหลดมาแล้ว
 *   (ไม่ยิง request ใหม่); ลูกค้าเลือกจาก**ชื่อ**ด้วยรายชื่อจาก `GET /v1/customers`
 * - **มีข้อมูลค้างแล้วออกจากหน้าต้องถามยืนยันด้วย UI ของแอปเอง** (D-116 ข้อ 2) —
 *   ไม่มีที่เก็บฉบับร่างฝั่งไหนเลย แถวที่ได้จาก upload นับเป็นของค้างเหมือนแถวที่
 *   กรอกมือ (`beforeunload` เตือนไว้ + ดัก `click` ที่ `document` แบบ capture ก่อน
 *   react-router จะ navigate เอง แล้วเปิดกล่องยืนยันของแอปเอง — **ไม่ใช้
 *   `window.confirm`/`alert`**)
 *
 * คำอธิบายรายช่อง (เดิมแสดงเต็มใต้ทุกช่อง) ย้ายเข้ากลไก (i) (`InfoHint`) ที่
 * `ProductListView` ใช้แล้ว (D-107 ข้อ 5, Comment 4) — ข้อความที่ผิดไปแล้ว (ความยาว
 * ของเลขที่ไม่มีอยู่แล้ว) ถูกลบทิ้ง ไม่ใช่ย้ายตาม
 *
 * `WO-P2-M4-012` (D-117, คำขอผู้ใช้ 2026-09-25) เพิ่มห้าเรื่องในตารางบรรทัด: ปุ่ม
 * เพิ่ม/ลบเป็น icon; หัวคอลัมน์ "Part Number" แทน "รหัสสินค้า" (ชื่อที่แสดงเท่านั้น
 * — payload ยังเป็น `product_code`); คอลัมน์ Part Name/Model อ่านอย่างเดียวถัดจาก
 * Part Number; ช่อง Part Number ค้นหาได้ผ่าน `GET /v1/products?status=ACTIVE&q=`
 * (`ProductCodeCell` ด้านล่าง — ต้องมี `PRODUCT_MASTER` VIEW, ไม่มีก็ยังพิมพ์ได้);
 * และหน่วยนับเติมจาก `base_uom` เมื่อ resolve สินค้าได้ (แถวจาก upload คงหน่วยตาม
 * ไฟล์เสมอ — ดู `withResolvedProduct`/`salesOrderLineDraftFromPreview`)
 */

import { useEffect, useId, useRef, useState, type ChangeEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import {
  ImportSpreadsheetFailureNotice,
  SalesOrderFailureNotice,
  TemplateDownloadFailureNotice,
} from './SalesOrderScreen';
import { InfoHint } from '../components/InfoHint';
import { Modal } from '../components/Modal';
import { fetchCustomers } from '../../lib/customers/client';
import { ACTIVE_CUSTOMER_STATUS, type Customer } from '../../lib/customers/types';
import { can } from '../../lib/permissions/client';
import type { PermissionsState } from '../../lib/permissions/types';
import { fetchProductList } from '../../lib/products/client';
import { PRODUCT_MASTER_MODULE, type Product } from '../../lib/products/types';
import { selectablePlants } from '../productionOrders/productionOrderView';
import {
  downloadSalesOrderImportTemplate,
  importCustomerPurchaseOrder,
  previewSalesOrderSpreadsheet,
  SALES_ORDER_SPREADSHEET_MEDIA_TYPE,
  type CustomerPoImportResult,
  type SalesOrderFailure,
} from '../../lib/sales/client';
import {
  EMPTY_SALES_ORDER_LINE_DRAFT,
  findProductByExactCode,
  hasSalesOrderReceiveDraftContent,
  isProductSearchQueryEligible,
  productOptionLabel,
  salesOrderFieldsFromPreview,
  salesOrderLineDraftFromPreview,
  toCreateSalesOrderBody,
  withClearedProductCode,
  withResolvedProduct,
  type CreateSalesOrderFields,
  type SalesOrderLineDraft,
} from '../../lib/sales/salesView';
import {
  CUSTOMER_PO_LINE_NO_MAX_LENGTH,
  CUSTOMER_PO_NUMBER_MAX_LENGTH,
  PRODUCT_CODE_MAX_LENGTH,
  SALES_MODULE,
  SALES_ORDER_LINE_REF_MAX_LENGTH,
  SO_NOTE_MAX_LENGTH,
  UOM_CODE_MAX_LENGTH,
} from '../../lib/sales/types';

/** debounce ของช่องค้นหา Part Number (D-117 ข้อ 2) — ทุกการกดแป้นไม่ใช่ทุกคำขอ */
const PRODUCT_SEARCH_DEBOUNCE_MS = 200;
/** จำนวนตัวเลือกสูงสุดที่ดรอปดาวน์แสดง — ผู้ใช้พิมพ์แคบลงเองถ้ายังไม่เจอ */
const PRODUCT_SEARCH_RESULT_LIMIT = 20;

interface ProductCodeCellProps {
  readonly position: number;
  readonly value: string;
  /** ว่างเปล่า = ยังไม่ได้ resolve — ใช้กันไม่ให้ค้นหาซ้ำแถวที่ resolve แล้ว (upload/เลือกแล้ว) */
  readonly productName: string;
  readonly disabled: boolean;
  /** สิทธิ์ `PRODUCT_MASTER` VIEW (D-117 ข้อ 3) — ไม่มีแล้วช่องยังพิมพ์ได้ แต่ไม่ค้น */
  readonly canSearch: boolean;
  readonly apiBaseUrl: string;
  readonly fetchImpl?: typeof fetch;
  readonly onCodeChange: (value: string) => void;
  readonly onResolved: (product: Product) => void;
}

/**
 * ช่อง Part Number แบบค้นหาได้ (D-117 ข้อ 1, 2, 3, 5, 6)
 *
 * พิมพ์อย่างน้อยสองตัวอักษร (debounce {@link PRODUCT_SEARCH_DEBOUNCE_MS} ms) →
 * แสดงตัวเลือกจาก `GET /v1/products?status=ACTIVE&q=` (`lib/products/client.ts`
 * ที่มีอยู่แล้ว — ไฟล์นั้นอยู่ใน forbidden_scope ของ Work Order นี้ ห้ามแก้)
 * เลือกแล้วเติม Part Name/Model/หน่วยทันที — หรือพิมพ์รหัสเต็มเองแล้วออกจากช่อง
 * (`onBlur`) ก็เติมให้เหมือนกันถ้ารหัส**ตรงทั้งตัว**กับสินค้าที่ `ACTIVE`
 *
 * **ไม่ค้นหาเลยเมื่อ `canSearch` เป็น false** (ไม่มีสิทธิ์ `PRODUCT_MASTER` VIEW) —
 * ช่องยังพิมพ์รหัสได้ปกติ แต่ไม่มีตัวเลือกและไม่เติมอัตโนมัติ เหตุผลอยู่ที่ (i) ของ
 * หัวคอลัมน์ ไม่ใช่ตรงช่องนี้ (ดู `SalesOrderReceivePage`)
 *
 * **ไม่ค้นซ้ำแถวที่ resolve แล้ว** (`productName !== ''`) — กันไม่ให้แถวจาก upload
 * (ซึ่งได้ชื่อ/โมเดลมาจาก preview ตรง ๆ, D-117 ข้อ 4) หรือแถวที่เพิ่งเลือกไปแล้ว
 * ยิงคำขอค้นหาซ้ำตอน mount/re-render — headline ของ Work Order นี้คือไฟล์ 200
 * บรรทัดต้องไม่กลายเป็น 200+N คำขอ
 *
 * ผลที่มาช้ากว่าคำค้นล่าสุดถูกทิ้งด้วย `requestIdRef` — เลขที่เพิ่มทุกครั้งที่ยิงคำขอ
 * จริง (ทั้งจาก debounce และจาก blur) ผลที่กลับมาไม่ตรงกับเลขล่าสุดคือของคำค้นเก่า
 */
function ProductCodeCell({
  position,
  value,
  productName,
  disabled,
  canSearch,
  apiBaseUrl,
  fetchImpl,
  onCodeChange,
  onResolved,
}: ProductCodeCellProps) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<readonly Product[]>([]);
  const [notFound, setNotFound] = useState(false);
  const requestIdRef = useRef(0);
  const listboxId = useId();

  useEffect(() => {
    if (!canSearch || productName !== '') {
      setOptions([]);
      setOpen(false);
      return;
    }
    const query = value.trim();
    if (!isProductSearchQueryEligible(query)) {
      setOptions([]);
      setOpen(false);
      return;
    }
    const timer = window.setTimeout(() => {
      const requestId = (requestIdRef.current += 1);
      void fetchProductList(
        { status: 'ACTIVE', q: query, limit: PRODUCT_SEARCH_RESULT_LIMIT },
        { apiBaseUrl, fetchImpl },
      ).then((result) => {
        // ผลที่มาช้ากว่าคำค้นล่าสุดต้องถูกทิ้ง ไม่งั้นตัวเลือกของคำเก่าจะมาทับของคำใหม่
        if (requestIdRef.current !== requestId) {
          return;
        }
        if (result.status === 'ready') {
          setOptions(result.page.items);
          setOpen(result.page.items.length > 0);
        } else {
          setOptions([]);
          setOpen(false);
        }
      });
    }, PRODUCT_SEARCH_DEBOUNCE_MS);
    return () => window.clearTimeout(timer);
  }, [value, productName, canSearch, apiBaseUrl, fetchImpl]);

  const handleSelect = (product: Product) => {
    onResolved(product);
    setOpen(false);
    setOptions([]);
    setNotFound(false);
  };

  /** ตรงทั้งรหัสตอนหลุดโฟกัส (D-117 ข้อ 6) — ไม่บล็อกการส่งไม่ว่าจะเจอหรือไม่เจอ */
  const handleBlur = () => {
    setOpen(false);
    const trimmed = value.trim();
    setNotFound(false);
    if (!canSearch || trimmed === '') {
      return;
    }
    const requestId = (requestIdRef.current += 1);
    void fetchProductList(
      { status: 'ACTIVE', q: trimmed, limit: PRODUCT_SEARCH_RESULT_LIMIT },
      { apiBaseUrl, fetchImpl },
    ).then((result) => {
      if (requestIdRef.current !== requestId || result.status !== 'ready') {
        return;
      }
      const match = findProductByExactCode(result.page.items, trimmed);
      if (match !== null) {
        onResolved(match);
      } else {
        setNotFound(true);
      }
    });
  };

  return (
    <div className="cap-product-search">
      <input
        className="cap-input"
        type="text"
        role="combobox"
        aria-expanded={open}
        aria-autocomplete="list"
        aria-controls={listboxId}
        name={`product_code_${position}`}
        data-testid={`so-create-line-product-${position}`}
        aria-label={`Part Number บรรทัดที่ ${position}`}
        value={value}
        maxLength={PRODUCT_CODE_MAX_LENGTH}
        autoComplete="off"
        disabled={disabled}
        onChange={(event) => {
          setNotFound(false);
          onCodeChange(event.target.value);
        }}
        onBlur={handleBlur}
      />
      {open && options.length > 0 ? (
        <ul
          id={listboxId}
          role="listbox"
          className="cap-product-search__options"
          data-testid={`so-create-line-product-options-${position}`}
        >
          {options.map((product) => (
            <li key={product.product_id} role="option" aria-selected="false">
              <button
                type="button"
                className="cap-product-search__option"
                data-testid={`so-create-line-product-option-${position}-${product.product_code}`}
                onMouseDown={(event) => {
                  // กัน blur ไม่ให้ยิงก่อน click — ไม่งั้นดรอปดาวน์ปิดก่อนที่ onClick จะทำงาน
                  event.preventDefault();
                }}
                onClick={() => {
                  handleSelect(product);
                }}
              >
                {productOptionLabel(product)}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      {notFound ? (
        <p className="cap-field__hint" data-testid={`so-create-line-product-notfound-${position}`}>
          ไม่พบรหัสนี้ในระบบ
        </p>
      ) : null}
    </div>
  );
}

export interface SalesOrderReceivePageProps {
  readonly permissions: PermissionsState;
  readonly apiBaseUrl: string;
  /** inject ได้เพื่อการทดสอบ — production ใช้ `fetch` ของเบราว์เซอร์ */
  readonly fetchImpl?: typeof fetch;
  /**
   * ส่งผลของการส่งกลับไปให้ `SalesOrderScreen` โหลดรายการใหม่แล้วพากลับ —
   * **`CustomerPoImportResult` ไม่ใช่ `SalesOrder`** (D-116 ข้อ 9) เพราะทุกการส่ง
   * เดินผ่าน `/import` แล้ว ผลจึงเป็นหนึ่งในสามทางของ D-092 เสมอ ไม่ใช่แค่ "สร้าง
   * ใหม่สำเร็จ" — ผู้เรียกเป็นผู้ตัดสินว่าแต่ละผลแสดงอย่างไร
   */
  readonly onSubmitted: (result: CustomerPoImportResult) => void;
}

/**
 * หนึ่งแถวของ line editor — `key` เป็นของ React ไม่ได้เดินทางไปไหน (แนวเดียวกับ
 * ที่กล่อง Modal เดิมเคยทำ — index จะถูกใช้ซ้ำทันทีที่ลบแถวกลางออก แล้วค่าที่
 * พิมพ์ไว้ในแถวถัด ๆ ไปจะเลื่อนตำแหน่งตามกันไปทั้งแถบ)
 */
interface CreateLineRow {
  readonly key: number;
  readonly draft: SalesOrderLineDraft;
}

function newLineRow(key: number): CreateLineRow {
  return { key, draft: EMPTY_SALES_ORDER_LINE_DRAFT };
}

const EMPTY_FIELDS: Omit<CreateSalesOrderFields, 'plantCode'> = {
  customerCode: '',
  customerPoNumber: '',
  note: '',
};

type CustomersState =
  | { readonly status: 'loading' }
  | { readonly status: 'ready'; readonly items: readonly Customer[] }
  | { readonly status: 'failed' };

export function SalesOrderReceivePage({
  permissions,
  apiBaseUrl,
  fetchImpl,
  onSubmitted,
}: SalesOrderReceivePageProps) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  /** ด่านเดียวกับปุ่มดาวน์โหลดฟอร์มบนหน้ารายการเดิม — ตรวจซ้ำแม้ route จะ gate VIEW ไว้แล้ว */
  const canView = can(permissions, SALES_MODULE, 'VIEW');
  const canCreate = can(permissions, SALES_MODULE, 'CREATE');
  /**
   * สิทธิ์ที่ตัวควบคุมของช่องค้นหา Part Number (D-117 ข้อ 3) — แบบเดียวกับที่ช่อง
   * ลูกค้าบนหน้านี้พึ่ง `CUSTOMER_MASTER` อยู่แล้ว ไม่มีสิทธิ์นี้ ช่องยังพิมพ์รหัสได้
   * แค่ไม่มีตัวเลือกและไม่เติมชื่อ/โมเดลอัตโนมัติ — ไม่ซ่อนช่องและไม่กันการส่ง
   */
  const canSearchProducts = can(permissions, PRODUCT_MASTER_MODULE, 'VIEW');

  /** โรงงานที่ `plant_scope` พามาถึง — ไม่มี request ใหม่ (D-116 ข้อ 6) */
  const plants = selectablePlants(permissions);

  const [fields, setFields] = useState<CreateSalesOrderFields>(() => ({
    ...EMPTY_FIELDS,
    plantCode: plants[0] ?? '',
  }));
  const [lines, setLines] = useState<readonly CreateLineRow[]>([newLineRow(0)]);
  const [nextKey, setNextKey] = useState(1);
  const [pending, setPending] = useState(false);
  const [failure, setFailure] = useState<SalesOrderFailure | null>(null);

  const [customers, setCustomers] = useState<CustomersState>({ status: 'loading' });
  const [customersReloadToken, setCustomersReloadToken] = useState(0);

  const [templateDownloadPending, setTemplateDownloadPending] = useState(false);
  const [templateDownloadFailure, setTemplateDownloadFailure] =
    useState<SalesOrderFailure | null>(null);

  /**
   * ผลของพรีวิว (D-116 ข้อ 5) — `wouldBe === null` แปลว่ายังไม่เคยพรีวิวไฟล์ใดเลย
   * ในรอบนี้ ไม่ใช่ "พรีวิวแล้วว่าง" (ใบว่างเปล่าไม่มีทางพรีวิวผ่านอยู่แล้ว —
   * `SALES_ORDER_HAS_NO_LINES` ฝั่งเซิร์ฟเวอร์กันไว้)
   */
  const [previewPending, setPreviewPending] = useState(false);
  const [previewFailure, setPreviewFailure] = useState<SalesOrderFailure | null>(null);
  const [wouldBe, setWouldBe] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  /** href ที่ผู้ใช้พยายามออกไป ระหว่างรอคำตอบจากกล่องยืนยัน (D-116 ข้อ 2) */
  const [pendingHref, setPendingHref] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setCustomers({ status: 'loading' });
    void fetchCustomers(
      { status: ACTIVE_CUSTOMER_STATUS },
      { apiBaseUrl, fetchImpl, signal: controller.signal },
    ).then((result) => {
      if (!active || result.status === 'cancelled') {
        return;
      }
      setCustomers(
        result.status === 'ready'
          ? { status: 'ready', items: result.page.items }
          : { status: 'failed' },
      );
    });
    return () => {
      active = false;
      controller.abort();
    };
  }, [apiBaseUrl, fetchImpl, customersReloadToken]);

  const lineDrafts: readonly SalesOrderLineDraft[] = lines.map((row) => row.draft);
  /**
   * `plantCode` ถูกยกเว้นจากการตรวจ "มีของค้าง" โดยตั้งใจ — มันถูกเติมให้เอง
   * ตั้งแต่ render แรก (ทั้งกรณีมีโรงงานเดียวและกรณีมีหลายโรงงานที่เลือกอันแรกไว้
   * ให้ก่อน) จึงไม่ใช่ค่าที่ผู้ใช้ "พิมพ์" — ถ้านับรวมด้วย หน้านี้จะถามยืนยันก่อน
   * ออกทันทีที่ render เสร็จ ทั้งที่ยังไม่มีใครแตะฟอร์มเลย
   */
  const dirty = hasSalesOrderReceiveDraftContent({ ...fields, plantCode: '' }, lineDrafts);

  /* -------------------------- D-116 ข้อ 2 — ปิดแท็บ/refresh ระหว่างมีของค้าง -- */
  useEffect(() => {
    if (!dirty) {
      return;
    }
    function handleBeforeUnload(event: BeforeUnloadEvent) {
      event.preventDefault();
      event.returnValue = '';
    }
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [dirty]);

  /**
   * D-116 ข้อ 2 — นำทางในแอป (crumb, เมนู, ปุ่มกลับ) ระหว่างมีของค้าง
   *
   * ทุกทางออกในแอปนี้เป็น `<Link>` ของ react-router (`HeaderBar` ของ breadcrumb,
   * `Sidebar` ของเมนู, และปุ่มกลับของหน้านี้เอง) — ไฟล์นี้ไม่มีสิทธิ์แก้
   * `HeaderBar.tsx` (forbidden_scope) จึงดัก `click` ที่ `document` แบบ capture
   * แทนการเจาะจงทีละองค์ประกอบ วิธีนี้ครอบคลุมทั้งสามทางออกด้วยกลไกเดียว
   */
  useEffect(() => {
    if (!dirty) {
      return;
    }
    function handleDocumentClick(event: MouseEvent) {
      if (event.defaultPrevented || event.button !== 0) {
        return;
      }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        // เปิดแท็บใหม่/ดาวน์โหลด — ปล่อยให้เบราว์เซอร์จัดการเองตามปกติ
        return;
      }
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      const anchor = target.closest('a[href]');
      if (!(anchor instanceof HTMLAnchorElement)) {
        return;
      }
      if (anchor.target !== '' && anchor.target !== '_self') {
        return;
      }
      let url: URL;
      try {
        url = new URL(anchor.href, window.location.href);
      } catch {
        return;
      }
      if (url.origin !== window.location.origin) {
        return;
      }
      if (url.pathname === window.location.pathname && url.search === window.location.search) {
        // ชี้กลับมาที่เดิม (เช่น crumb ตัวสุดท้าย) — ไม่มีอะไรให้ยืนยัน
        return;
      }
      event.preventDefault();
      // ต้องหยุด propagation ด้วย ไม่ใช่แค่ preventDefault — `Link` ผูก `onClick`
      // ของตัวเองที่จะ navigate ซ้ำถ้า event เดินทางไปถึงมัน
      event.stopPropagation();
      setPendingHref(`${url.pathname}${url.search}${url.hash}`);
    }
    document.addEventListener('click', handleDocumentClick, true);
    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
    };
  }, [dirty]);

  const updateField = (field: keyof CreateSalesOrderFields, value: string) => {
    setFields((previous) => ({ ...previous, [field]: value }));
  };

  const addLine = () => {
    setLines((previous) => [...previous, newLineRow(nextKey)]);
    setNextKey((key) => key + 1);
  };

  const removeLine = (key: number) => {
    setLines((previous) => previous.filter((row) => row.key !== key));
  };

  const updateLine = (key: number, field: keyof SalesOrderLineDraft, value: string) => {
    setLines((previous) =>
      previous.map((row) =>
        row.key === key ? { ...row, draft: { ...row.draft, [field]: value } } : row,
      ),
    );
  };

  /**
   * แก้ Part Number ของแถวนั้น — **ล้าง Part Name/Model เดิมทันที** (D-117 ข้อ 1,
   * headline ของ Work Order นี้) ชื่อที่ไม่ตรงกับรหัสบนหน้าจอคืออันตรายที่สุดใน
   * ตารางนี้ ทางเดียวที่ productCode เปลี่ยนคือทางนี้ — พิมพ์เองก็ผ่านที่นี่
   */
  const handleProductCodeChange = (key: number, value: string) => {
    setLines((previous) =>
      previous.map((row) =>
        row.key === key ? { ...row, draft: withClearedProductCode(row.draft, value) } : row,
      ),
    );
  };

  /**
   * เลือกสินค้าจากตัวเลือก หรือพิมพ์รหัสเต็มตรงทั้งตัวแล้วหลุดโฟกัส (D-117 ข้อ 1,
   * 2, 5, 6) — เติม Part Name/Model และตั้งหน่วยเป็น `base_uom` ของสินค้านั้น
   * (ยังแก้ต่อได้) `withResolvedProduct` เป็นจุดเดียวที่เขียนสามฟิลด์นี้พร้อมกัน
   */
  const handleProductResolved = (key: number, product: Product) => {
    setLines((previous) =>
      previous.map((row) =>
        row.key === key ? { ...row, draft: withResolvedProduct(row.draft, product) } : row,
      ),
    );
  };

  const body = toCreateSalesOrderBody(fields, lineDrafts);

  /**
   * **ส่งผ่าน `POST /v1/sales-orders/import` เสมอ** (D-092, D-116 ข้อ 9) — ทั้งกรอก
   * มือและหลัง upload เดินทางเดียวกัน เพราะพรีวิวทำนายผลด้วยตรรกะของเส้นนี้พอดี
   * ห้ามสลับไปเรียก `createSalesOrder()` (`POST /v1/sales-orders` ตรง) เด็ดขาด —
   * ใบที่ preview บอกว่า "เปิดการแก้ไขใบเดิม" จะได้ `409` แทนถ้าส่งอีกทาง
   */
  const submit = async () => {
    if (body === null || pending) {
      return;
    }
    setPending(true);
    setFailure(null);
    const result = await importCustomerPurchaseOrder(body, { apiBaseUrl, fetchImpl });
    setPending(false);
    if (result.status === 'cancelled') {
      return;
    }
    if (result.status !== 'ready') {
      // **ไม่นำทางไปไหนเลย** — สิ่งที่กรอกไว้ทั้งหัวใบและทุกบรรทัดยังอยู่ครบให้แก้
      // แล้วส่งใหม่ได้ทันที ซึ่งสำหรับ `SO_NUMBER_TAKEN` คือสิ่งเดียวที่ต้องทำ
      setFailure(result);
      return;
    }
    onSubmitted(result.result);
  };

  const handleDownloadTemplate = async () => {
    if (!canView || templateDownloadPending) {
      return;
    }
    setTemplateDownloadPending(true);
    setTemplateDownloadFailure(null);
    const result = await downloadSalesOrderImportTemplate({ apiBaseUrl, fetchImpl });
    setTemplateDownloadPending(false);
    if (result.status !== 'ready') {
      setTemplateDownloadFailure(result);
    }
  };

  /** เปิด dialog เลือกไฟล์ — ปุ่มที่ผู้ใช้เห็นคือ `<button>` ข้างล่าง */
  const handleUploadClick = () => {
    if (!canCreate || previewPending) {
      return;
    }
    fileInputRef.current?.click();
  };

  /**
   * พรีวิวไฟล์ที่เลือกแล้ว (D-116 ข้อ 5) — **ไม่เขียนอะไรเลย** เติมหัวใบและทุก
   * บรรทัดที่อ่านได้ลง**ตารางเดียวกับที่กรอกมือ** (D-116 ข้อ 9: การแก้ค่าในตารางหลัง
   * upload ไม่ทำให้สองเส้นทางให้ผลต่างกัน เพราะ `/import` ตัดสินใหม่ตอนส่งจริงเสมอ)
   * แถวเดิมที่ยังไม่ได้ส่งถูกแทนที่ทั้งหมด — พรีวิวคือ "นี่คือใบที่ไฟล์นี้จะสร้าง"
   * ไม่ใช่ "ต่อท้ายแถวเดิม"
   */
  const handleFileSelected = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] ?? null;
    // ล้างค่าทันที ไม่งั้นเลือกไฟล์ชื่อเดิมซ้ำครั้งที่สองจะไม่ยิง `change` เลย
    event.target.value = '';
    if (file === null || !canCreate || previewPending) {
      return;
    }

    setPreviewPending(true);
    setPreviewFailure(null);
    setWouldBe(null);
    const result = await previewSalesOrderSpreadsheet(file, { apiBaseUrl, fetchImpl });
    setPreviewPending(false);
    if (result.status === 'cancelled') {
      return;
    }
    if (result.status !== 'ready') {
      setPreviewFailure(result);
      return;
    }

    const preview = result.preview;
    setFields(salesOrderFieldsFromPreview(preview));
    setLines(
      preview.lines.length === 0
        ? [newLineRow(nextKey)]
        : preview.lines.map((line, index) => ({
            key: nextKey + index,
            draft: salesOrderLineDraftFromPreview(line),
          })),
    );
    setNextKey((key) => key + Math.max(preview.lines.length, 1));
    setWouldBe(preview.would_be);
    setFailure(null);
  };

  const busy = pending;

  return (
    <div className="cap-page" data-testid="sales-order-receive">
      <div className="cap-page__head">
        <div>
          <h1 className="cap-page__title">
            รับใบสั่งซื้อของลูกค้า
            <InfoHint
              label="เกี่ยวกับหน้านี้"
              text="กรอก Customer PO เข้าเป็นใบสั่งขายใหม่ ด้วยมือหรืออัปโหลดไฟล์ Excel ก็ได้ — ข้อมูลที่กรอกหรืออัปโหลดมาแต่ยังไม่กดส่งค้างอยู่ในหน้าจอนี้อย่างเดียว ไม่มีการเก็บที่ไหน refresh หรือปิดแท็บจะทำให้หายจริง (D-116 ข้อ 2)"
            />
          </h1>
        </div>
        <div className="cap-page__actions">
          <Link
            className="cap-button cap-button--ghost"
            data-testid="so-receive-back"
            to={{ pathname, search: '' }}
          >
            ← กลับไปหน้ารายการ
          </Link>
          <button
            type="button"
            className="cap-button cap-button--ghost"
            data-testid="so-receive-download-template"
            disabled={!canView || templateDownloadPending}
            title={canView ? undefined : `ต้องมีสิทธิ์ ${SALES_MODULE} + VIEW จึงจะดาวน์โหลดฟอร์มนี้ได้`}
            onClick={() => {
              void handleDownloadTemplate();
            }}
          >
            {templateDownloadPending ? 'กำลังดาวน์โหลด…' : 'ดาวน์โหลดฟอร์ม Excel'}
          </button>
          <button
            type="button"
            className="cap-button cap-button--ghost"
            data-testid="so-receive-upload-trigger"
            disabled={!canCreate || previewPending}
            title={
              canCreate ? undefined : `ต้องมีสิทธิ์ ${SALES_MODULE} + CREATE จึงจะอัปโหลดไฟล์ได้`
            }
            onClick={handleUploadClick}
          >
            {previewPending ? 'กำลังอ่านไฟล์…' : 'อัปโหลดไฟล์ Excel'}
          </button>
          {/*
            input ที่แท้จริง — ซ่อนจากทั้งเลย์เอาต์และ accessibility tree ด้วยตั้งใจ
            (`aria-hidden` + `tabIndex={-1}`) เพราะปุ่มข้างบนเป็นตัวควบคุมที่ผู้ใช้
            เห็นและกดจริง input นี้เป็นแค่กลไกเปิด native file picker ผ่าน `.click()`
          */}
          <input
            ref={fileInputRef}
            type="file"
            accept={`.xlsx,${SALES_ORDER_SPREADSHEET_MEDIA_TYPE}`}
            aria-hidden="true"
            tabIndex={-1}
            style={{ display: 'none' }}
            data-testid="so-receive-upload-input"
            onChange={(event) => {
              void handleFileSelected(event);
            }}
          />
        </div>
      </div>

      {templateDownloadFailure === null ? null : (
        <TemplateDownloadFailureNotice
          failure={templateDownloadFailure}
          onRetry={() => {
            setTemplateDownloadFailure(null);
          }}
        />
      )}

      {previewFailure === null ? null : (
        <ImportSpreadsheetFailureNotice failure={previewFailure} />
      )}

      {wouldBe === null ? null : (
        <div className="cap-notice" data-testid="so-receive-preview" data-would-be={wouldBe} role="status">
          <p className="cap-notice__text">
            ไฟล์ที่อัปโหลดเติมหัวใบและบรรทัดด้านล่างให้แล้ว — แก้ต่อได้ก่อนกดส่งจริง
            เหมือนกรอกมือ ผลที่คาดว่าจะเกิดถ้ากดส่งตอนนี้คือ{' '}
            <code className="cap-table__code" data-testid="so-receive-preview-outcome">
              {wouldBe}
            </code>{' '}
            (ผลจริงยืนยันอีกครั้งตอนกดส่ง — D-092)
          </p>
        </div>
      )}

      <form
        className="cap-form"
        data-testid="so-create-form"
        aria-label="รับใบสั่งซื้อของลูกค้าเข้าระบบ"
        onSubmit={(event) => {
          event.preventDefault();
          void submit();
        }}
      >
        <label className="cap-field">
          <span className="cap-field__label">
            โรงงาน
            <InfoHint
              label="เกี่ยวกับช่องโรงงาน"
              text="มาจากโรงงานที่คุณมีสิทธิ์เข้าถึงเท่านั้น (D-004) — ใบสั่งขายหนึ่งใบเป็นของโรงงานเดียว"
            />
          </span>
          <select
            className="cap-input"
            name="plant_code"
            data-testid="so-create-plant"
            value={fields.plantCode}
            disabled={busy}
            onChange={(event) => {
              updateField('plantCode', event.target.value);
            }}
          >
            {plants.length === 0 ? <option value="">— ไม่มีโรงงานที่คุณเห็น —</option> : null}
            {plants.map((code) => (
              <option key={code} value={code}>
                โรงงาน {code}
              </option>
            ))}
          </select>
        </label>

        <label className="cap-field">
          <span className="cap-field__label">
            ลูกค้า
            <InfoHint
              label="เกี่ยวกับช่องลูกค้า"
              text="เลือกจากชื่อลูกค้า — ลูกค้าที่ถูกระงับหรือเลิกค้าขายแล้วรับคำสั่งซื้อใหม่ไม่ได้"
            />
          </span>
          <select
            className="cap-input"
            name="customer_code"
            data-testid="so-create-customer"
            value={fields.customerCode}
            disabled={busy || customers.status !== 'ready'}
            onChange={(event) => {
              updateField('customerCode', event.target.value);
            }}
          >
            <option value="">— เลือกลูกค้า —</option>
            {customers.status === 'ready'
              ? customers.items.map((customer) => (
                  <option key={customer.customer_id} value={customer.customer_code}>
                    {customer.customer_name} ({customer.customer_code})
                  </option>
                ))
              : null}
          </select>
          <span className="cap-field__hint">
            {customers.status === 'loading'
              ? 'กำลังโหลดรายชื่อลูกค้า…'
              : customers.status === 'failed'
                ? 'โหลดรายชื่อลูกค้าไม่สำเร็จ'
                : null}
            {customers.status === 'failed' ? (
              <>
                {' '}
                <button
                  type="button"
                  className="cap-button cap-button--ghost"
                  data-testid="so-receive-customers-retry"
                  onClick={() => {
                    setCustomersReloadToken((token) => token + 1);
                  }}
                >
                  ลองอีกครั้ง
                </button>
              </>
            ) : null}
          </span>
        </label>

        <label className="cap-field">
          <span className="cap-field__label">
            เลขใบสั่งซื้อของลูกค้า
            <InfoHint
              label="เกี่ยวกับช่องเลขใบสั่งซื้อของลูกค้า"
              text={`เลข ของลูกค้า ยาวได้ถึง ${CUSTOMER_PO_NUMBER_MAX_LENGTH} ตัวอักษร (เราคุมรูปแบบไม่ได้) — คู่ (ลูกค้า, เลขนี้) รับเข้าได้ครั้งเดียว เพื่อกันการผลิตและส่งของซ้ำ`}
            />
          </span>
          <input
            className="cap-input"
            name="customer_po_number"
            data-testid="so-create-po-number"
            value={fields.customerPoNumber}
            maxLength={CUSTOMER_PO_NUMBER_MAX_LENGTH}
            autoComplete="off"
            disabled={busy}
            onChange={(event) => {
              updateField('customerPoNumber', event.target.value);
            }}
          />
        </label>

        <label className="cap-field">
          <span className="cap-field__label">หมายเหตุ (ไม่บังคับ)</span>
          <input
            className="cap-input"
            name="note"
            data-testid="so-create-note"
            value={fields.note}
            maxLength={SO_NOTE_MAX_LENGTH}
            autoComplete="off"
            disabled={busy}
            onChange={(event) => {
              updateField('note', event.target.value);
            }}
          />
        </label>

        <fieldset className="cap-field" data-testid="so-create-lines">
          <legend className="cap-field__label">
            บรรทัดบนใบสั่งซื้อของลูกค้า
            <InfoHint
              label="เกี่ยวกับตารางบรรทัด"
              text="คีย์ทุกบรรทัดที่อยู่บนเอกสารของลูกค้า — เลขบรรทัดคือเลขของลูกค้าที่เขาใช้อ้างกลับมาหาเรา จึงห้ามซ้ำกันเองในใบเดียว ใบต้องมีอย่างน้อยหนึ่งบรรทัดจึงจะรับเข้าได้ Ref1–Ref6 เป็นช่องอ้างอิงอิสระไม่มีความหมายตายตัว ใช้ map ตอน Packing/จัดส่ง (D-107 ข้อ 2) ปล่อยว่างได้"
            />
          </legend>

          <div className="cap-table-wrap">
            <table className="cap-table" data-testid="so-create-lines-table">
              <caption className="cap-visually-hidden">
                บรรทัดที่จะรับเข้าเป็นใบสั่งขาย พร้อมปุ่มลบรายบรรทัด
              </caption>
              <thead>
                <tr>
                  <th scope="col">เลขบรรทัด PO ลูกค้า</th>
                  <th scope="col">
                    Part Number
                    <InfoHint
                      label="เกี่ยวกับช่อง Part Number"
                      text={
                        canSearchProducts
                          ? 'พิมพ์อย่างน้อยสองตัวอักษรเพื่อค้นหาสินค้าที่ ACTIVE จากทะเบียน หรือพิมพ์รหัสเต็มแล้วออกจากช่องเพื่อเติม Part Name/Model/หน่วยให้อัตโนมัติ — พิมพ์รหัสเองได้เสมอแม้ไม่ตรงกับที่ค้นเจอ เซิร์ฟเวอร์เป็นผู้ตัดสินสุดท้าย'
                          : `ต้องมีสิทธิ์ ${PRODUCT_MASTER_MODULE} + VIEW จึงจะค้นหาสินค้าได้ — พิมพ์รหัสได้ตามปกติ แต่จะไม่มีตัวเลือกให้เลือกและไม่เติม Part Name/Model/หน่วยอัตโนมัติ`
                      }
                    />
                  </th>
                  <th scope="col">Part Name</th>
                  <th scope="col">Model</th>
                  <th scope="col">จำนวน</th>
                  <th scope="col">หน่วย</th>
                  <th scope="col">ต้องการรับของวันที่</th>
                  <th scope="col">Ref1</th>
                  <th scope="col">Ref2</th>
                  <th scope="col">Ref3</th>
                  <th scope="col">Ref4</th>
                  <th scope="col">Ref5</th>
                  <th scope="col">Ref6</th>
                  <th scope="col">ลบ</th>
                </tr>
              </thead>
              <tbody>
                {lines.map((line, index) => (
                  <tr key={line.key} data-testid={`so-create-line-${index + 1}`}>
                    <td>
                      <input
                        className="cap-input"
                        name={`customer_po_line_no_${index + 1}`}
                        data-testid={`so-create-line-no-${index + 1}`}
                        aria-label={`เลขบรรทัด PO ของลูกค้า บรรทัดที่ ${index + 1}`}
                        value={line.draft.customerPoLineNo}
                        maxLength={CUSTOMER_PO_LINE_NO_MAX_LENGTH}
                        autoComplete="off"
                        disabled={busy}
                        onChange={(event) => {
                          updateLine(line.key, 'customerPoLineNo', event.target.value);
                        }}
                      />
                    </td>
                    <td>
                      <ProductCodeCell
                        position={index + 1}
                        value={line.draft.productCode}
                        productName={line.draft.productName}
                        disabled={busy}
                        canSearch={canSearchProducts}
                        apiBaseUrl={apiBaseUrl}
                        fetchImpl={fetchImpl}
                        onCodeChange={(value) => {
                          handleProductCodeChange(line.key, value);
                        }}
                        onResolved={(product) => {
                          handleProductResolved(line.key, product);
                        }}
                      />
                    </td>
                    <td>
                      <span
                        className="cap-table__muted"
                        data-testid={`so-create-line-name-${index + 1}`}
                      >
                        {line.draft.productName === '' ? '—' : line.draft.productName}
                      </span>
                    </td>
                    <td>
                      <span
                        className="cap-table__muted"
                        data-testid={`so-create-line-model-${index + 1}`}
                      >
                        {line.draft.model === '' ? '—' : line.draft.model}
                      </span>
                    </td>
                    <td>
                      <input
                        className="cap-input"
                        name={`quantity_${index + 1}`}
                        data-testid={`so-create-line-quantity-${index + 1}`}
                        aria-label={`จำนวน บรรทัดที่ ${index + 1}`}
                        value={line.draft.quantity}
                        inputMode="decimal"
                        autoComplete="off"
                        disabled={busy}
                        onChange={(event) => {
                          updateLine(line.key, 'quantity', event.target.value);
                        }}
                      />
                    </td>
                    <td>
                      <input
                        className="cap-input"
                        name={`uom_code_${index + 1}`}
                        data-testid={`so-create-line-uom-${index + 1}`}
                        aria-label={`หน่วยนับ บรรทัดที่ ${index + 1}`}
                        value={line.draft.uomCode}
                        maxLength={UOM_CODE_MAX_LENGTH}
                        autoComplete="off"
                        disabled={busy}
                        onChange={(event) => {
                          updateLine(line.key, 'uomCode', event.target.value);
                        }}
                      />
                    </td>
                    <td>
                      <input
                        className="cap-input"
                        type="date"
                        name={`requested_delivery_date_${index + 1}`}
                        data-testid={`so-create-line-date-${index + 1}`}
                        aria-label={`วันที่ต้องการรับของ บรรทัดที่ ${index + 1}`}
                        value={line.draft.requestedDeliveryDate}
                        disabled={busy}
                        onChange={(event) => {
                          updateLine(line.key, 'requestedDeliveryDate', event.target.value);
                        }}
                      />
                    </td>
                    {(['ref1', 'ref2', 'ref3', 'ref4', 'ref5', 'ref6'] as const).map((ref) => (
                      <td key={ref}>
                        <input
                          className="cap-input"
                          name={`${ref}_${index + 1}`}
                          data-testid={`so-create-line-${ref}-${index + 1}`}
                          aria-label={`${ref} บรรทัดที่ ${index + 1}`}
                          value={line.draft[ref]}
                          maxLength={SALES_ORDER_LINE_REF_MAX_LENGTH}
                          autoComplete="off"
                          disabled={busy}
                          onChange={(event) => {
                            updateLine(line.key, ref, event.target.value);
                          }}
                        />
                      </td>
                    ))}
                    <td>
                      <button
                        type="button"
                        className="cap-button cap-button--ghost cap-button--icon"
                        data-testid={`so-create-line-remove-${index + 1}`}
                        aria-label={`ลบบรรทัดที่ ${index + 1}`}
                        title={`ลบบรรทัดที่ ${index + 1}`}
                        disabled={busy}
                        onClick={() => {
                          removeLine(line.key);
                        }}
                      >
                        <span aria-hidden="true">🗑️</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button
            type="button"
            className="cap-button cap-button--ghost cap-button--icon"
            data-testid="so-create-line-add"
            aria-label="เพิ่มบรรทัด"
            title="เพิ่มบรรทัด"
            disabled={busy}
            onClick={addLine}
          >
            <span aria-hidden="true">➕</span>
          </button>
        </fieldset>

        <div className="cap-form__actions">
          <button
            type="submit"
            className="cap-button cap-button--primary"
            data-testid="so-create-submit"
            disabled={busy || body === null}
          >
            {pending ? 'กำลังรับใบ…' : 'รับใบเข้าระบบ'}
          </button>
          <Link
            className="cap-button cap-button--ghost"
            data-testid="so-create-cancel"
            to={{ pathname, search: '' }}
          >
            ยกเลิก
          </Link>
        </div>

        <p className="cap-field__hint" data-testid="so-create-summary">
          มี {lines.length} บรรทัด
          {body === null
            ? ' — ปุ่มรับใบยังกดไม่ได้จนกว่าหัวใบจะครบ และทุกบรรทัดจะมีเลขบรรทัด สินค้า จำนวนที่มากกว่าศูนย์ หน่วยนับ และวันที่ต้องการรับของครบ'
            : ''}
        </p>

        {failure === null ? null : <SalesOrderFailureNotice failure={failure} context="create" />}
      </form>

      {pendingHref === null ? null : (
        <Modal open onClose={() => setPendingHref(null)} title="ออกจากหน้านี้โดยไม่บันทึก?">
          <p className="cap-notice__text" data-testid="so-receive-leave-confirm-text">
            สิ่งที่กรอกไว้ในหน้านี้ยังไม่ถูกส่งเข้าระบบ และไม่มีที่เก็บฉบับร่างไว้เลย —
            ออกจากหน้านี้แล้วข้อมูลทั้งหมดจะหายทันที
          </p>
          <div className="cap-form__actions">
            <button
              type="button"
              className="cap-button cap-button--primary"
              data-testid="so-receive-leave-confirm"
              onClick={() => {
                const href = pendingHref;
                setPendingHref(null);
                navigate(href);
              }}
            >
              ออกจากหน้านี้
            </button>
            <button
              type="button"
              className="cap-button cap-button--ghost"
              data-testid="so-receive-leave-cancel"
              onClick={() => {
                setPendingHref(null);
              }}
            >
              อยู่ต่อ
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}
